import * as React from "react";
const SvgIconUpDownFilter = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", fillOpacity: 0.87, d: "M7 15l5 5.5 5-5.5H7zM7 9.5L12 4l5 5.5H7z" }));
export default SvgIconUpDownFilter;
